import React from 'react'
import { LayoutRoot } from './root/layout-root'
import { LayoutOrg } from './org/layout-org'
import { LayoutAdmin } from './admin/layout-admin'
import { UnknownRoute } from '../../page/not-found'

// The three role layouts draw their own routes side by side; UnknownRoute
// draws the not-found page for a URL none of them knows.
export const LayoutAuthorized = () => {
  return (
    <React.Fragment>
      <LayoutRoot />
      <LayoutAdmin />
      <LayoutOrg />
      <UnknownRoute />
    </React.Fragment>
  )
}
